import { Button } from "@mui/material";
import CGIEventsHeader from "../Common/Header/CGIEventsHeader";
import { useState, useRef } from "react";
import { postHelpDeskData } from '../../api/additionals';
import useCustomNavigation from '../../hooks/useCustomNavigation';
import { ROUTES } from '../../constants/routes';
import { useTranslation } from 'react-i18next';
const Field = ({ label, value, onChange, placeholder, error }) => (
	<div className={'nameWrapper'}>
		<label className={'name-input-label'}>{label}</label>
		<span className="star-css-span ">*</span>
		<div className={'input-text-wrapper'}>
			<input
				type={'text'}
				id={'name'}
				value={value}
				className='input'
				placeholder={placeholder}
				onChange={onChange}
				disabled={false}
			/>
		</div>
		{error && <p className="error-text">{error}</p>}
	</div>
);

// const Dropdown = ({
// 	label,
// 	value,
// 	onChange,
// 	options = [],
// 	placeholder,
// 	error,
// }) => (
// 	<div className={'nameWrapper'}>
// 		<label className={'name-input-label'}>{label}</label>
// 		<span className="star-css-span">*</span>

// 		<div className={'input-text-wrapper'}>
// 			<select
// 				id="dropdown"
// 				value={value}
// 				className="input"
// 				onChange={onChange}>
// 				<option value="" disabled>
// 					{"Select an option"}
// 				</option>
// 				{options.map((option, index) => (
// 					<option key={index} value={option.value}>
// 						{option.label}
// 					</option>
// 				))}
// 			</select>
// 		</div>

// 		{error && <p className="error-text">{error}</p>}
// 	</div>
// );


const MessageField = ({ label, value, onChange, error, placeHolder }) => (
	<div className={'nameWrapper'}>
		<label className={'name-input-label'}>{label}</label>
		<span className="star-css-span ">*</span>
		<div className={'input-message-wrapper'}>
			<textarea
				type={'text'}
				className='input'
				placeholder={placeHolder}
				value={value}
				onChange={onChange}
			/>
		</div>
		{error && <p className="error-text">{error}</p>}
	</div>
);
const HelpDeskPage = () => {
	const { t } = useTranslation();
	const fileInputRef = useRef(null);
	const navigation = useCustomNavigation();

	const [form, setForm] = useState({
		name: "",
		email: "",
		subject: "",
		message: "",
		requestType:""
	});

// 	const requestTypeOptions = [
//   		{ label: "Enhancement", value: "enhancement" },
//   		{ label: "Bug", value: "bug" },
// ];

	const [errors, setErrors] = useState({});
	const [attachments, setAttachments] = useState([]);
	const activeIndex = useRef(null);


	const handleChange = (field, value) => {
		setForm(prev => ({
			...prev,
			[field]: value
		}));

		setErrors(prev => ({
			...prev,
			[field]: ""
		}));
	};
	const handleFileSelect = (e) => {
		const files = Array.from(e.target.files);

		setAttachments(prev => {
			const updated = [...prev];

			files.forEach((file, i) => {
				updated[activeIndex.current + i] = file;
			});

			return updated;
		});

		e.target.value = "";
	};



	const openBrowser = index => {
		activeIndex.current = index;
		fileInputRef.current.click();
	};


	const validate = () => {
		let newErrors = {};

		if (!form.name.trim()) newErrors.name = "Name is required";

		if (!form.email.trim()) {
			newErrors.email = "Email is required";
		} else if (!/\S+@\S+\.\S+/.test(form.email)) {
			newErrors.email = "Enter valid email address";
		}

		if (!form.subject.trim()) newErrors.subject = "Subject is required";

		if (!form.message.trim()) newErrors.message = "Message is required";

		setErrors(newErrors);

		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = async () => {
		if (!validate()) return;

		try {
			const formData = new FormData();

			formData.append("name", form.name);
			formData.append("email", form.email);
			formData.append("subject", form.subject);
			formData.append("message", form.message);
			// formData.append("requestType", form.requestType);


			// FIX: Append multiple files correctly
			attachments.forEach((file, index) => {
				if (file) {
					formData.append("attachments", file);
				}
			});

			await postHelpDeskData(formData);

			alert("Ticket Submitted successfully");
			navigation.push(ROUTES.LOGIN, { isPasswordLogin: false });

		} catch (err) {
			console.log("Submit error:", err);
			alert("Something went wrong");
		}
	};




	return (
		<>
			<CGIEventsHeader />
			<div className={'helpdesk-form-page'}>
				<div className="button-fixed-at-bottom-static">
					<div className="bg-gray-100 px-4 py-6 flex justify-center">
						<div className="nameWrapper">

							<h1 className="name-input-label">
								{t('helpDesk.submitRequest')}
							</h1>
							{/* Name */}
							<Field
								//  ref={nameRef}
								label={t('helpDesk.name')}
								value={form.name}
								onChange={(e) => handleChange("name", e.target.value)}
								placeholder="First & Last Name"
								error={errors.name}
							/>

							<Field
								label={t('helpDesk.email')}
								value={form.email}
								onChange={(e) => handleChange("email", e.target.value)}
								placeholder="email@cgi.com"
								error={errors.email}
							/>
							{/* Request Type */}
							{/* <Dropdown
								label={t('helpDesk.requestType')}
								value={form.requestType}
								onChange={(e) =>
									setForm({ ...form, requestType: e.target.value })
								}
								options={requestTypeOptions}
								placeholder={t('helpDesk.SelectRequestType')}
								error={errors.requestType}
							/> */}

							{/* Subject */}
							<Field
								label={t('helpDesk.subject')}
								value={form.subject}
								onChange={(e) => handleChange("subject", e.target.value)}
								placeholder="Enter subject(Login issue etc).."
								error={errors.subject}
							/>

							{/* Message */}
							<MessageField
								label={t('helpDesk.message')}
								value={form.message}
								onChange={(e) => handleChange("message", e.target.value)}
								error={errors.message}
								placeHolder={t('helpDesk.typeYourMessage')}
							/>

							{/* Attachments */}
							<div className="attachment-section">
								<p className="attachment-label">{t('helpDesk.attachments')}</p>

								<div className="attachment-box">
									<div className="button-row">
										<Button className="browse-btn"
											onClick={() => openBrowser(0)}
											disabled={!!attachments[0]}>
											{t('helpDesk.openBrowser')}
										</Button>
									</div>

									<div className="button-row">
										<Button className="browse-btn"
											onClick={() => openBrowser(1)}
											disabled={!!attachments[1]}>
											{t('helpDesk.openBrowser')}
										</Button>
									</div>
									<div className="button-row">
										<Button className="browse-btn"
											onClick={() => openBrowser(2)}
											disabled={!!attachments[2]}>
											{t('helpDesk.openBrowser')}
										</Button>
									</div>
									<div>
										{attachments.map((file, index) => (
											file && <p key={index} className="attachment-label">
												📎 {file.name}
											</p>
										))}
									</div>
									<p className="attachment-label">{t('helpDesk.attachmentAllowed')} </p>

								</div>
								<input
									type="file"
									accept="*"
									hidden
									ref={fileInputRef}
									onChange={handleFileSelect}
								/>
							</div>

							<div className="submit-box">
								<div className="button-row">
									<Button className="browse-btn" onClick={handleSubmit}>
										{t('helpDesk.submitTicket')}
									</Button>
								</div>
							</div>


						</div>
					</div>

				</div>
			</div>
		</>

	);
};

export default HelpDeskPage;
